import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UploadImagesScreen from './components/UploadImages/UploadImagesScreen';
import Dashboard from './components/dashboard/Dashboard';
import axios from 'axios';
import { getAuthToken } from './utils/authStorage';

// Base URL configurada por entorno (staging apunta a aeryum-back-dev, prod a aeryum-back-prod)
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080';
axios.defaults.baseURL = API_BASE;

const PUBLIC_AUTH_PATHS = [
  '/auth/login',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
];

axios.interceptors.request.use((config) => {
  const requestUrl = new URL(config.url || '', config.baseURL || API_BASE);
  if (PUBLIC_AUTH_PATHS.includes(requestUrl.pathname)) {
    delete config.headers.Authorization;
    delete config.headers.authorization;
  }
  return config;
});

// Helper global: convierte una ruta relativa de proxy (/api/images/proxy?...) en URL absoluta
// para usarla directamente en <img src> sin pasar por nginx
window.__toAbsoluteUrl = (relativePath) => {
  if (!relativePath) return null;
  if (relativePath.startsWith('http')) return relativePath;
  return API_BASE.replace(/\/$/, '') + relativePath;
};

// Restaurar el token si ya existe en localStorage (persiste entre recargas)
const savedToken = getAuthToken();
if (savedToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <App/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
